import React from 'react';

function Q1({ question = 1, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a title</span>
        <h1>Project Valen</h1>
        <p>Oh look, a button.</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center">
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button"
        onClick={() => onNavigate?.('q2')}
      >
        Click me
      </button>
    </div>
  </div>
  );
}

export default Q1;
